import { AcadNavTabs } from "@components";

import routes from "./SchoolsRoutes";

const SchoolPage = () => {
  return <AcadNavTabs {...{ routes }} />;
};

export default SchoolPage;
